<template>
  <div class="introduction-tab-wrap">
    <div :class="`tab-item ${activeKey&&activeKey === item.name?'active':''}`"
    :key="`${item.name}-${index}`"
    v-for="(item, index) in tabArr"
    @click="toTabPage(item.name)">
      <span class="tab-txt">{{item.text}}</span>
    </div>
  </div>
</template>
<script>
import { reactive } from '@vue/reactivity'
import { useI18n } from 'vue-i18n'
import {  useRouter } from 'vue-router'
export default {
  name:'introduction-tab-comp',
  props:{
    activeKey:{
      type: String,
      default: null
    }
  },
  setup(){
    const { t }  = useI18n()
    const router = useRouter()
    const tabArr = reactive([
        {
          name:'stock-hk',
          text: t('common.sotck_hk')
        },
        {
          name:'stock-usa',
          text: t('common.sotck_us')
        },
        {
          name:'stock-cn',
          text: t('common.sotck_A')
        }
    ])
    const toTabPage = (name)=>{
      router.push({
        name
      })
    }
    return {
      t,
      tabArr,
      toTabPage
    }
  }
}
</script>
<style lang="stylus">
.introduction-tab-wrap
  display: flex
  flex-direction row
  justify-content center
  align-items center
  position absolute
  left 0
  top 0
  right 0
  height 80px
  background $introduction-stock-page-bg
  background var(--introduction-stock-page-bg)
  .tab-item
    padding 0 24px
    height: 100%
    box-sizing border-box
    .tab-txt
      display: block
      font-size 28px
      line-height 90px
      color $introduction-stock-tab-color
      color var(--introduction-stock-tab-color)
    &.active
      .tab-txt
        color $introduction-stock-tab-active-color
        color var(--introduction-stock-tab-active-color)
        position relative
        &::after
          position absolute
          content ''
          display block
          left 50%
          top 70px
          transform translate(-50%,0)
          width 32px
          height 8px
          border-radius 4px
          background $introduction-stock-tab-active-line
          background var(--introduction-stock-tab-active-line)

</style>